// Data model — the same lesson/item shape as the Python Speak2Remember /
// EED reference and the React Native port, so a lessons list stays portable
// across all of them (export here, import there).

export interface PlayItem {
  key_seq: number;
  eng_text: string;
  kor_text: string;
  mp3_path: string;
  audio_output: string;
  num1: number;
  num2: number;
  pack: string;
  title: string;
  // Additive fields (ignored by the reference parser): the voice to speak
  // with, and the text to actually speak when it differs from eng_text
  // (persona mode strips the "NAME:" prefix).
  voice?: string;
  speak_text?: string;
}

export interface Lesson {
  sid: number;
  content_id: string;
  part: string;
  unit: string;
  course: string;
  items: PlayItem[];
}

export type Screen =
  | 'unit_list'
  | 'scenario_menu'
  | 'card_play'
  | 'dictation'
  | 'expression_list'
  | 'add_sentences';

// Saved study settings + progress (persisted as JSON in localStorage).
export interface Progress {
  show_meaning: boolean;
  show_word: boolean;
  repeat_speed: SpeedKey;
  repeat_count: RepeatKey;
  auto_advance: boolean;
  last_positions: Record<number, number>;
}

export type SpeedKey = 'slow' | 'normal' | 'fast';
export type RepeatKey = 'one' | 'twice' | 'three' | 'five' | 'infinite';

// Matches StorageManager.CONTENT_ID in the Android build, so exported data
// stays usable there. Older data used the opaque reference id below and is
// migrated on load — see storage.ts.
export const CONTENT_ID = 'speak2remember';
export const LEGACY_CONTENT_ID = '20120314I0000002';

export function emptyItem(): PlayItem {
  return {
    key_seq: 0,
    eng_text: '',
    kor_text: '',
    mp3_path: '',
    audio_output: '',
    num1: 0,
    num2: 0,
    pack: '',
    title: '',
  };
}

export function audioBasename(item: PlayItem): string {
  const fromPath = item.mp3_path.replace(/\\/g, '/').split('/').pop() ?? '';
  if (fromPath) return fromPath;
  return item.audio_output.replace(/\\/g, '/').split('/').pop() ?? '';
}
